"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadJs = void 0;
/*
 * @Author: liujunhong
 * @Date: 2022/9/24
 * @Desc: 公用方法
 */
/**
 * @typedef LoadJs
 * @description 动态插入js
 * @property src
 * @property insert 标签script插入位置，head顶位置，为空插入在底部
 * @property cb 回调函数
 * @property async 是否异步加载
 * @property id 标识
 */
var loadJs = function loadJs(props) {
  var src = props.src,
    _props$insert = props.insert,
    insert = _props$insert === void 0 ? 'head' : _props$insert,
    cb = props.cb,
    _props$async = props.async,
    async = _props$async === void 0 ? true : _props$async,
    id = props.id;
  return new Promise(function (res, rej) {
    var script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = async;
    if (id) {
      script.id = id;
    }
    script.onload = function () {
      return res({
        code: 0
      });
    };
    script.onerror = function (err) {
      return rej({
        code: 1,
        err: err
      });
    };
    if (insert === 'head') {
      document.head.appendChild(script);
    } else {
      document.body.appendChild(script);
    }
    // 回调处理
    if (!cb) return;
    if (window.ActiveXObject || 'ActiveXObject' in window) {
      // 判断是否是ie
      if (script.readyState) {
        // 判断是否支持readyState
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            cb();
          }
        };
      } else {
        script.onload = function () {
          cb();
        };
      }
    } else {
      // 非ie
      script.onload = function () {
        cb();
      };
    }
  });
};
exports.loadJs = loadJs;